'use strict';

module.exports = function () {
    $('body')
        .off('change.orderHistory', 'select.order-history-select')
        .on('change.orderHistory', 'select.order-history-select', function (e) {
            
            var $ordersContainer = $('.js-order-history-container');
            $ordersContainer.empty();
            $.spinner().start();
            $('select.order-history-select').trigger('orderHistory:sort', e);
            
            $.ajax({
                url: e.currentTarget.value,
                method: 'GET',
                success: function (data) {
                    $ordersContainer.html(data);
                    $('select.order-history-select').selectpicker('destroy').selectpicker();
                    $.spinner().stop();
                },
                error: function (err) {
                    if (err.responseJSON && err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                    $.spinner().stop();
                }
            });
        });
};
